
import { useIsMobile } from "../../../hooks/useIsMobile";
import { Mobile } from "./mobile";
import { Desktop } from "./desktop";
import styles from "./index.module.scss";
import { useEffect, useRef } from "react";

type FooterProps = {
    onHeightChange?: (height: number) => void;
};

export const Footer = ({ onHeightChange }: FooterProps) => {
    const isMobile = useIsMobile();
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!ref.current) return;
        const handleResize = () => {
            if (ref.current && onHeightChange) {
                onHeightChange(ref.current.offsetHeight);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [onHeightChange]);

    return (
        <div className={styles.footer} ref={ref}>
            {isMobile ? <Mobile /> : <Desktop />}
        </div>
    );
};